import React from 'react';
import { feedback, actions } from '@ecosystem/newron-design-system';
import { Cell } from '../types';

const { Tooltip } = feedback;
const { Button } = actions;

const TOOLTIP_COUNT = 10;

type FooterProps = {
  handleApply: () => void;
  handleCancel: () => void;
  selectedCells: Cell[];
  primaryBtnText?: string;
  isCancelDisabled?: boolean;
};

export const Footer = ({
  handleApply,
  handleCancel,
  selectedCells,
  isCancelDisabled,
  primaryBtnText = 'Apply',
}: FooterProps) => {
  const MarketsSelected = (
    <Tooltip placement="bottom">
      <span className="underline">{selectedCells.length} markets</span> selected
      <Tooltip.Content>
        {selectedCells
          .map(sm => sm.label)
          .slice(0, TOOLTIP_COUNT)
          .join(', ')}
        {selectedCells.length > TOOLTIP_COUNT && '...'}
      </Tooltip.Content>
    </Tooltip>
  );

  return (
    <div
      className="flex h-18 items-center justify-between border-t border-light px-4 py-4 flex items-end gap-3"
      data-test-id="multicell-selector-footer"
    >
      <Button mode="secondary" onClick={handleCancel} disabled={isCancelDisabled}>
        Cancel
      </Button>
      <div>
        <span className="text-lighter text-base mr-2">
          {selectedCells.length !== 0 ? MarketsSelected : 'Select any number of product groups'}
        </span>
        {selectedCells.length !== 0 && <Button onClick={handleApply}>{primaryBtnText}</Button>}
      </div>
    </div>
  );
};
